import { FC } from 'react';

import VideoModal from 'src/components/common/modal/videoModal';

const ExploreWalkthroughModal: FC = () => (
    <VideoModal videoUrl="https://www.youtube.com/watch?v=vqdxl3T6bhk&ab_channel=apadua" />
);

export default ExploreWalkthroughModal;
